import { createElement, useState, createContext, useContext, Fragment, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { SpeechManager } from '@sas/direct-speech';

import cn from './DirectSpeech.css.json';
import './DirectSpeech.css';

const DirectSpeechContext = createContext<undefined | SpeechManager>(undefined);

/**
 * This is used internally by AppRoot. Consumers should not need to use this in isolation.
 */
export const DirectSpeechProvider = (props: { children?: ReactNode }) => {
  const [speechManager, setSpeechManager] = useState<SpeechManager | undefined>(undefined);

  return (
    <Fragment>
      {createPortal(
        <div
          ref={(ref) => {
            if (!speechManager && ref) {
              setSpeechManager(new SpeechManager(ref));
            }
          }}
          className={cn.speechContainer}
          role="status"
          aria-live="assertive"
          aria-atomic
          aria-relevant="additions text"
        />,
        document.body
      )}

      <DirectSpeechContext.Provider value={speechManager}>
        {props.children}
      </DirectSpeechContext.Provider>
    </Fragment>
  );
};
/**
 * Hook for using the DirectSpeechContext
 */
export function useDirectSpeech() {
  // This will return undefined until SpeechManager is succesfully constructed after we have our speech container div ref
  return useContext(DirectSpeechContext);
}
